import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Checkbox } from 'semantic-ui-react';
import _ from 'lodash';

import { fetchStudents, addStudentToApp } from '../state/studentlookup/actions';

import { Filter, Main } from 'Containers';
import { StudentLookupGrid } from 'Common/Components/StudentLookupGrid/StudentLookupGrid';
import { ApplicationFieldEnum as Fields } from 'Common/FieldEnum';
import { NEW_STUDENT } from '../helpers/Constants';
import {
  getUpdatedApplication,
  setAppRecalculated,
} from '../state/hub/actions';

class StudentLookup extends Component {
  static path = '/manageapplication/:familyId/studentlookup';
  state = {
    onSelect: () => {},
    addNewStudent: () => {},
    showWithdrawn: false,
    addedStudentId: null,
  };

  componentDidUpdate(prevProps) {
    const { history } = this.props;
    const currentQueryString = _.get(history, 'location.search', '');

    if (prevProps.studentsOnApp.length < this.props.studentsOnApp.length) {
      this.props.getUpdatedApplication();
    } else if (!prevProps.appRecalculated && this.props.appRecalculated) {
      this.props.setAppRecalculated(false);

      history.push(
        `${this.getRootUrl()}/student/${
          this.state.addedStudentId
        }${currentQueryString}`
      );
    }
  }

  componentDidMount() {
    if (!this.props.appExists) {
      this.props.history.push(this.getRootUrl());
    } else {
      this.setState({
        onSelect: (student) => {
          this.setState({ addedStudentId: student[Fields.Id] }, () => {
            this.props.addStudentToApp(student);
          });
        },
        addNewStudent: () => {
          this.setState({ addedStudentId: NEW_STUDENT[Fields.Id] }, () => {
            this.props.addStudentToApp({ ...NEW_STUDENT });
          });
        },
      });
    }
  }

  getRootUrl = () => {
    return this.props.match.url.replace(/\/studentlookup*/gi, '');
  };

  showWithdrawnChange = (e, data) => {
    this.setState({ showWithdrawn: data.checked });
  };

  fetchData = ({ page, filtered, sorted }, showWithdrawn) => {
    this.props.fetchStudents(page, filtered, sorted, showWithdrawn);
  };

  getMainProps = () => {
    return {
      toolbox: {
        backButtonProps: { shown: true, path: this.getRootUrl() },
        shown: true,
      },
    };
  };

  render() {
    const { students, fetching, totalPages, studentIdsOnApp } = this.props;
    const { onSelect, showWithdrawn, addNewStudent } = this.state;

    return (
      <Fragment>
        <Filter title={'Student Lookup'}>
          <Grid>
            <Grid.Row>
              <Grid.Column width={'5'}>
                <Checkbox
                  toggle
                  disabled={fetching}
                  label={'Show Withdrawn'}
                  onChange={this.showWithdrawnChange}
                />
              </Grid.Column>
              <Grid.Column width={'5'} floated={'right'} textAlign={'right'}>
                <Button content={'Add New Student'} onClick={addNewStudent} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Filter>
        <Main {...this.getMainProps()}>
          <StudentLookupGrid
            loading={fetching}
            onFetchData={this.fetchData}
            onSelect={onSelect}
            showWithdrawn={showWithdrawn}
            students={students}
            disabledStudents={studentIdsOnApp}
            totalPages={totalPages}
            buttonText={'Add'}
            buttonTextDisabled={'On App'}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { studentLookup, hub } = state.ManageApplicationState;
  const appExists = Object.keys(hub.tempApplication).length > 0;
  const studentIdsOnApp = appExists
    ? hub.tempApplication.Students.map((s) => s[Fields.Id])
    : [];

  return {
    appExists,
    studentIdsOnApp,
    fetching: studentLookup.fetching,
    students: studentLookup.students,
    totalPages: studentLookup.totalPages,
    studentsOnApp: hub.tempApplication.Students,
    appRecalculated: hub.appRecalculated,
    isSecondReview: hub.isSecondReview,
  };
};

StudentLookup = connect(mapStateToProps, {
  fetchStudents,
  addStudentToApp,
  getUpdatedApplication,
  setAppRecalculated,
})(StudentLookup);

export { StudentLookup };



// WEBPACK FOOTER //
// ./src/pages/manageapplication/subpages/StudentLookup.js